import http from "../../http";
import {useAuth} from "../../hooks/useAuth";
import {useUser} from "../../hooks/useUser";
import {queryClient} from "../../client";
import store from "../index";
import {useRole} from "../../hooks/useRole";

const state = () => ({
  authenticated: false,
  user: null,
});

const {refreshToken, login, logout} = useAuth();
const {current} = useUser();

const getters = {
  user: state => state.user,
  isAuthenticated: state => state.authenticated,
  registrationCompleted: state => state.user?.registration_completed ?? false,
};

const actions = {
  async login({ commit }, {email, password}) {
    try {
      await login(email, password);
    } catch (e) {
      commit('SET_AUTHENTICATED', false);
      throw e;
    }
  },

  async logout({ commit }, {silence} = {silence: false}) {
    await logout();

    store.dispatch('user/removeStripeConnectFlag', false);

    if (!silence) {
      commit('SET_AUTHENTICATED', false);
      commit('SET_USER', null);
    }
  },

  async refreshToken() {
    await refreshToken();
  },

  async user({ commit }) {
    try {
      const data = await current();

      commit('SET_AUTHENTICATED', true);
      commit('SET_USER', data);
    } catch (e) {
      commit('SET_AUTHENTICATED', false);
      commit('SET_USER', null);

      throw e;
    }
  },
};

const mutations = {
  SET_AUTHENTICATED(state, value) {
    state.authenticated = value;
  },

  SET_USER(state, data) {
    queryClient.setQueryData('userCurrent', () => data);

    state.user = data?.data;

    if (state.user?.current_brand_id) {
      http.defaults.headers['Current-Brand-Id'] = data.data.current_brand_id;
    }

    const {isCreator, isBrand} = useRole();

    if (state.user?.email && window.$crisp) {
      try {
        window.$crisp.push(['set', 'user:email', [state.user?.email]]);

        const role = isCreator.value
          ? 'creator'
          : isBrand.value ? 'brand' : null;

        if (role) {
          $crisp.push(['set', 'session:segments', [[role]]]);
        }
      } catch (e) {
        console.error(e);
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
